"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const TextInput_1 = __importDefault(require("../TextInput"));
const helpers_1 = require("./helpers");
const BirthdayInput = ({ control, ...rest }) => {
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: "birthday", render: ({ field, fieldState }) => {
            const { ref: inputRef, ...fieldProps } = field;
            return ((0, jsx_runtime_1.jsx)(TextInput_1.default
            // eslint-disable-next-line react/jsx-props-no-spreading
            , { ...fieldProps, InputLabelProps: {
                    htmlFor: "birthday-input",
                }, InputProps: {
                    inputProps: {
                        "data-testid": "birthday-input",
                    },
                }, autoComplete: "bday", error: fieldState.invalid, helperText: fieldState.invalid ? "Invalid birth date" : undefined, id: "birthday-input", inputRef: inputRef, label: "Birthday", placeholder: "MM/DD/YYYY", value: (0, helpers_1.maskBirthday)(field.value || ""), ...rest }));
        }, rules: {
            pattern: {
                value: helpers_1.dateRegex,
                message: "Invalid date format. Format should match mm/dd/yyyy",
            },
            validate: helpers_1.validateBirthday,
        } }));
};
exports.default = BirthdayInput;
//# sourceMappingURL=index.js.map